import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// import { v4 as uuidv4 } from 'uuid';

import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import ErrorMessage from '../../components/common/ErrorMessage.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';
import ReportingSubLinks from '../../components/header/ReportingSubLinks.jsx';
import { setActiveTab } from '../../redux/slices/header-slice.js';

import useReporting from '../../hooks/useReporting.js';

/**
 * Format a readable date range
 */
const formatDateRange = (start, end) => {
    if (!start || !end) return '';

    const options = { year: 'numeric', month: 'short', day: 'numeric' };

    const startDate = new Date(start).toLocaleDateString(undefined, options);
    const endDate = new Date(end).toLocaleDateString(undefined, options);

    return `${startDate} – ${endDate}`;
};

/**
 * Renders Copilot Weekly Ticket Reporting page
 */
const CopilotWeeklyReportPage = () => {
    const dispatch = useDispatch();
    const { loading, error, getCopilotWeeklyReports } = useReporting();

    const [reports, setReports] = useState([]);

    useEffect(() => {
        dispatch(setActiveTab('Reporting'));
        return () => dispatch(setActiveTab(null));
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getCopilotWeeklyReports();
            if (data) setReports(data);
        };

        fetchData();
    }, []);

    // For header summary range (oldest → newest)
    const oldestReport = reports[reports.length - 1];
    const newestReport = reports[0];

    return (
        <div>
            <ReportingSubLinks />
            <div className="newsc-container" style={{ marginBottom: '2em' }}>
                <br />
                <br />
                <br />

                <div
                    style={{
                        position: 'sticky',
                        top: '64px',
                        zIndex: 10,
                        backgroundColor: '#fff',
                        paddingBottom: '12px',
                        borderBottom: '1px solid #e5e5e5'
                    }}>
                    <div className="create-office-heading">
                        <BackArrow navigateTo={-1} />

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                textAlign: 'left'
                            }}>
                            <h2 style={{ marginBottom: '6px' }}>
                                Copilot Weekly Ticket Report
                            </h2>

                            <div
                                style={{
                                    display: 'flex',
                                    gap: '24px',
                                    color: '#666',
                                    fontSize: '14px'
                                }}>
                                <span>Showing last {reports.length} weeks</span>

                                {oldestReport && newestReport && (
                                    <span>
                                        {formatDateRange(
                                            oldestReport.weekStart,
                                            newestReport.weekEnd
                                        )}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {loading && <LoadingSpinner />}
                {error && <ErrorMessage message={error.message} />}

                {!loading && !error && (
                    <div
                        style={{
                            marginTop: '16px',
                            maxHeight: 'calc(100vh - 240px)',
                            overflowY: 'auto',
                            paddingRight: '8px'
                        }}>
                        {/* Empty state */}
                        {reports.length === 0 && (
                            <p>No Copilot data available for this period.</p>
                        )}

                        {reports.map((report) => (
                            <div
                                key={report._id}
                                style={{
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    marginBottom: '20px',
                                    maxWidth: '900px'
                                }}>
                                <h3 style={{ marginBottom: '4px' }}>
                                    {formatDateRange(
                                        report.weekStart,
                                        report.weekEnd
                                    )}
                                </h3>

                                <div
                                    style={{
                                        fontSize: '13px',
                                        color: '#777',
                                        marginBottom: '8px'
                                    }}>
                                    Week {report.weekLabel}
                                </div>

                                <p>
                                    <b>Total Tickets:</b> {report.totalTickets}
                                </p>

                                {/* Required Tags */}
                                <h4>Primary Tags</h4>
                                <table className="stat-table">
                                    <thead>
                                        <tr>
                                            <th>Tag</th>
                                            <th>Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(
                                            report.requiredTags || {}
                                        ).map(([tag, count]) => (
                                            <tr key={tag}>
                                                <td>{tag}</td>
                                                <td>{count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* Optional Tags */}
                                <h4 style={{ marginTop: '1em' }}>
                                    Optional Tags / Subtags
                                </h4>
                                <table className="stat-table">
                                    <thead>
                                        <tr>
                                            <th>Tag</th>
                                            <th>Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(
                                            report.optionalTags || {}
                                        ).map(([tag, count]) => (
                                            <tr key={tag}>
                                                <td>{tag}</td>
                                                <td>{count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CopilotWeeklyReportPage;
